import { Flex, Grid } from '@chakra-ui/react';
import { FC } from 'react';
import { ProductType } from '../types/ProductType';
import ProductCard from './ProductCard';

const StoreProductsList: FC<{ products: ProductType[] }> = ({ products = [] }) => {
  if (products.length >= 4) {
    return (
      <Grid
        gap='6'
        templateColumns={{
          base: 'repeat(1, 1fr)',
          md: 'repeat(2, 1fr)',
          lg: 'repeat(3, 1fr)',
          xl: 'repeat(4, 1fr)',
        }}
        w='full'
      >
        {products.map((product) => (
          <ProductCard
            key={product.slug}
            product={product}
          />
        ))}
      </Grid>
    );
  }

  return (
    <Flex
      flexWrap='wrap'
      gap='6'
      justifyContent='center'
      w='full'
    >
      {products.map((product) => (
        <ProductCard
          key={product.slug}
          flexGrow={{ base: 1, lg: 0 }}
          product={product}
          w={{ base: 'full', md: '30%', lg: '25%' }}
        />
      ))}
    </Flex>
  );
};

export default StoreProductsList;
